import { ColumnType } from 'antd/es/table';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation } from "react-router";
import dayjs from 'dayjs';
import { phaseApis } from "../../api/Phase";
import { TooltipComponent } from "../../components/Component";
import { updateActivityInDetailModalSlice } from '../../store/slices/projectManagement/activity-view/ActivityInDetailView';
import { activityApis } from '../../api/Activity';
import { useWbsName } from "../ProjectScheduleManagement/shared/useWbsCodes";

const ActivityWiseTimeLogs = () => {
    const dispatch = useDispatch();
  const wbsName = useWbsName();
    const location = useLocation();
    const [ownerFilterData, setOwnerFilterData] = useState([]);
    const { id: projectId } = location.state || {};

    const columns: ColumnType<any>[] = [
        {
            title: "Activity Name",
            dataIndex: "activityName",
            key: "activityName",
            width: 150,
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`Activity-${record?.activityId}`}
                            onClick={() => {
                                console.log("Task Name Clicked:");
                                dispatch(
                                    updateActivityInDetailModalSlice({
                                        id: record.activityId,
                                        activeTab: "view",
                                        onClose: "openProjectModal",
                                        allowEdit: false,
                                        open: true,

                                    })
                                );
                            }}
                        >
                            {wbsName(text)}
                        </span>
                        <TooltipComponent
                            iconClass="info-circle text-info"
                            icon={""}
                            id={`task-${record?.taskId}`}
                            direction="right"
                            text={"Click To View " + text + " Details"}
                            containerClassName={"mt-1"}
                        />
                    </>
                );
            },
        },
        {
            title: "User",
            dataIndex: "userName",
            key: "userName",
            width: 150,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Date",
            dataIndex: "Date",
            key: "Date",
            width: 150,
            render: (text: string) => text || "N/A"
        },
        {
            title: "Total Hours",
            dataIndex: "totalHours",
            key: "plannedHours",
            width: 150,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : `${text} Hrs`)
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            key: "remarks",
            width: 150,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
    ];


    const fetchOwnerFilterData = async () => {
        try {
            const response = await activityApis.getOwnersFilterData(
                projectId?.toString(),
                null
            );
            const { data, status } = response || {};
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item.userName,
                        value: item.userId,
                    };
                });
                setOwnerFilterData(options);
            }
        } catch (error) {
            console.error("Error loading data:", error);
        }
    };

    useEffect(() => {
        fetchOwnerFilterData();
        dispatch(
            updateMenuData([
               {
                    text: "Task-Wise Time Logs",
                    link: "pms/task-wise-timelogs",
                },
                {
                    text: "Activity-Wise Time Logs",
                    link: "pms/activity-wise-timelogs",
                },
                {
                    text: "Phase-Wise Time Logs",
                    link: "pms/phase-wise-timelogs",
                },
            ])
        );
    }, []);

    return (
        <>
            <Template1
                moduleKey={window.location.pathname}
                columns={columns}
                pageTitle='ActivityWIse Time Logs Report'
                pageDescription=''
                previousPath={{
                    link: "/pms/project/reports",
                    state: location.state,
                }}
                filters={{
                    defaultFilters: {
                        dateRange: {
                            title: "Activity Actual Start Date",
                        },
                    },
                    customFilters: [
                        {
                            type: "multiple_selection",
                            name: "UserId",
                            label: "Users",
                            options: ownerFilterData,
                        },
                    ]
                }}
            />
        </>
    )
};

export default ActivityWiseTimeLogs;